import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import * as graph from '@adc/sdk'
import ListingBadge, { BADGE_MODE, BADGE_ORDER_PRIORITY } from './base'
import { isTPSLive, isForeclosure } from './utils'

const listingStatus = listing => _.get(listing, 'listing_status', '')

class ClearedForSaleYesBadge extends ListingBadge {
  static title = 'Cleared For Auction'

  static titleIcon = 'clipboard-check'

  static contentPositive = true

  static summary = 'Yes'

  static content =
    'We confirmed that this property will sell on auction day. It should not be postponed or cancelled.'

  static titleV2 = 'Cleared For Sale'
  static renderPriorityV2 = () => BADGE_ORDER_PRIORITY.FIRST

  static shouldBeIncluded(listing, badgeMode) {
    // only applies to expanded, hide for condensed
    return (
      (badgeMode === BADGE_MODE.EXPANDED || badgeMode === BADGE_MODE.V2) &&
      listingStatus(listing) === graph.enums.ListingStatus.SalePendingCleared &&
      isTPSLive(listing)
    )
  }

  static shouldBeIncludedV2(listing, badgeMode) {
    return this.shouldBeIncluded(listing, badgeMode) && isForeclosure(listing)
  }
}

class ClearedForSaleComingSoonBadge extends ListingBadge {
  static title = 'Cleared For Auction'

  static titleIcon = 'clipboard-check'

  static contentPositive = false

  static summary = 'No'

  static content =
    'This property is postponed. Awaiting new auction date and time.'

  static shouldBeIncluded(listing, badgeMode) {
    // only applies to expanded, hide for condensed
    return (
      badgeMode === BADGE_MODE.EXPANDED &&
      listingStatus(listing) ===
        graph.enums.ListingStatus.PostponedPendingScheduling &&
      isTPSLive(listing)
    )
  }
}

class ClearedForSalePendingBadge extends ListingBadge {
  static title = 'Cleared For Auction'

  static titleIcon = 'clipboard-check'

  static contentPositive = false

  static summary = 'Not Yet'

  static shouldBeIncluded(listing, badgeMode) {
    // only applies to expanded, hide for condensed
    return (
      badgeMode === BADGE_MODE.EXPANDED &&
      listingStatus(listing) === graph.enums.ListingStatus.SalePending &&
      isTPSLive(listing)
    )
  }

  renderNotifyMe() {
    return this.props.listing.primary_property?.is_currently_saved ? (
      "You'll be notified"
    ) : (
      <a onClick={e => this.emitEvent('notify_me', e)}>Notify Me</a>
    )
  }

  get content() {
    return (
      <>
        The auction is scheduled. It may be cancelled or postponed.
        <br />
        {this.renderNotifyMe()} when it's cleared for sale.
      </>
    )
  }
}

class ClearedForSalePostponedBadge extends ListingBadge {
  static title = 'Cleared For Auction'

  static titleIcon = 'clipboard-check'

  static contentPositive = false

  static summary = 'No'

  static shouldBeIncluded(listing, badgeMode) {
    // only applies to expanded, hide for condensed
    return (
      badgeMode === BADGE_MODE.EXPANDED &&
      listingStatus(listing) ===
        (listingStatus(listing) === graph.enums.ListingStatus.Postponed ||
          graph.enums.ListingStatus.SaleFailed) &&
      isTPSLive(listing)
    )
  }

  get content() {
    const postponementDate = _.get(
      this.props.listing,
      'listing_configuration.postponement_new_auction_date',
      ''
    )
    let postponedDate = moment(postponementDate, 'YYYY-MM-DD')
    postponedDate = postponedDate.isValid()
      ? postponedDate.format('MMM DD')
      : 'TBD'
    return <>No, this auction has been postponed to {postponedDate}</>
  }
}

export {
  ClearedForSalePostponedBadge,
  ClearedForSalePendingBadge,
  ClearedForSaleComingSoonBadge,
  ClearedForSaleYesBadge,
}
